<template>
  <div v-loading="loading" class="formData">
    <div v-if="form">
      <!-- 車主資料 -->
      <Quota
        ref="formQuota"
        :form="form"
        :applicationType="applicationType"
        :applicantType="applicantType"
      ></Quota>
      <!-- 車輛資料 -->
      <Vehicle
        ref="formVehicle"
        :form="form"
        :applicationType="applicationType"
      ></Vehicle>

      <!-- 支票資料 -->
      <!-- <Cheque
        v-if="applicationType == 'FIRST'"
        ref="formCheque"
        :form="form"
      ></Cheque> -->

      <!-- 駕駛人資料 -->
      <Drivers
        v-if="applicationType == 'FIRST'"
        ref="formDrivers"
        :form="form"
        :applicationType="applicationType"
      ></Drivers>

      <div class="next_btn">
        <p class="m-tempsave-tips">{{ $t("message.tempSave_tips") }}</p>
        <GradientBtn :loading="submitLoading" @click="next()">{{
          $t("message.DataRegistration.formData.next")
        }}</GradientBtn>
      </div>
    </div>
  </div>
</template>

<script>
import Quota from "./components/Quota";
import Vehicle from "./components/Vehicle";
// import Cheque from "./components/Cheque";
import Drivers from "./components/Drivers";
import GradientBtn from "../../../components/GradientBtn";
import HzmbApplicationAPI from "@/api/HzmbApplicationAPI";
import { applicationTypeFilter, applicantTypeFilter } from "@/filters";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
export default {
  components: {
    Quota,
    // Cheque,
    Drivers,
    Vehicle,
    GradientBtn,
  },
  data() {
    return {
      loading: false,
      form: null,
      config: {},
      submitLoading: false,
    };
  },
  computed: {
    verifyForm() {
      return this.$store.state.verifyForm;
    },
    serviceType() {
      return this.$store.state.serviceType;
    },
    applicationType() {
      return applicationTypeFilter(this.serviceType);
    },
    applicantType() {
      return applicantTypeFilter(this.serviceType);
    },
  },
  methods: {
    async next() {
      let formQuota = this.$refs["formQuota"].validateForm();
      let formVehicle = this.$refs["formVehicle"].validateForm();
      // let formCheque =
      //   this.applicationType == "RENEW"
      //     ? true
      //     : this.$refs["formCheque"].validateForm();
      let formDrivers =
        this.form.drivers.length > 0
          ? this.$refs["formDrivers"].validateForm()
          : true;

      if (formQuota && formVehicle && formDrivers) {
        const applicationType = this.applicationType;
        // 暫存
        let form = JSON.parse(JSON.stringify(this.form));
        form.spNo = this.verifyForm.spNo;
        form.serviceType = this.serviceType;
        form.language = this.$t("message.lang");
        delete form.quota.vssMacauAddress;
        // 駕駛人
        form.drivers = form.drivers.map((item) => {
          // 國籍處理
          item.nationality = item.otherNationality
            ? item.otherNationalityText
            : item.nationality;
          return item;
        });
        // 刪除車輛編號和車身後8位
        delete form.vehicle.regAndIdNo;
        // 內地車牌加上“粤”
        if (form.vehicle.mainlandRegistrationNo)
          form.vehicle.mainlandRegistrationNo =
            "粤" + form.vehicle.mainlandRegistrationNo;
        try {
          this.submitLoading = true;
          if (applicationType === "FIRST") {
            await HzmbApplicationAPI.saveFirst(form);
          }
          if (applicationType === "RENEW") {
            await HzmbApplicationAPI.saveRenew(form);
          }
          this.$router.push("/upload");
        } catch (error) {
          this.$error(error);
        } finally {
          this.submitLoading = false;
        }

        this.$store.commit("changeFirstApplicationCheck", true);
      } else {
        this.$store.commit("changeFirstApplicationCheck", false);
        this.$message({
          message: this.$t("message.form_error"),
          type: "error",
        });
        setTimeout(() => {
          document.querySelector(".el-form-item.is-error").scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 200);
      }
    },
    // 獲取vss數據
    getVss() {
      this.loading = true;
      const serviceType = this.serviceType;
      const verifyForm = this.$store.state.verifyForm;
      let identType = "BM";
      let identNo = verifyForm.identityNo;
      if (this.applicantType == "COMPANY") {
        if (verifyForm.companyType && verifyForm.companyNo) {
          identType = verifyForm.companyType;
          identNo = verifyForm.companyNo;
        } else {
          this.$message({
            type: "error",
            message: this.$t("message.different_login_type"),
          });
          this.$notify({
            type: "error",
            showClose: false,
            title: this.$t("message.tips"),
            message: this.$t("message.backToHome"),
            position: "bottom-right",
            duration: 4500,
          });
          setTimeout(() => {
            const page = localStorage.getItem("childTempTitle") || "one";
            if (page == "three") {
              this.$router.push("/entryTaxi");
            } else if (page == "two") {
              this.$router.push("/entryBus");
            } else {
              this.$router.push("/entry");
            }
          }, 5000);
          return;
        }
      }
      const spNo = verifyForm.spNo || null;
      const registrationNo = verifyForm.registrationNo || null;
      const identificationNo = verifyForm.identificationNo || null;
      HzmbApplicationAPI.getVss(
        serviceType,
        identType,
        identNo,
        spNo,
        registrationNo,
        identificationNo
      )
        .then((res) => {
          // console.log(res);
          this.loading = false;
          // let application = res.application;
          if (res.success) {
            this.form = this.formatForm(res);
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: res.errorMsgs
                .map((item) => {
                  return item.textCn;
                })
                .join("/n"),
            });
            // this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.$error(err);
          // this.$router.go(-1);
        });
    },
    formatForm(res) {
      this.$store.commit("changeVssForm", res);
      let resetForm = {
        quota: {
          macauAddress: {
            textCn: "",
            textPt: "",
          },
        },
        vehicle: {},
        cheque: {},
        drivers:
          this.applicationType == "FIRST"
            ? [
                {
                  macauAddress: {
                    textCn: "",
                    textPt: "",
                  },
                },
              ]
            : [],
      };
      let verifyForm = this.$store.state.verifyForm;
      let application = res.application;
      if (application) {
        let quota = application.quota;
        if (quota) {
          // 電話去掉區號
          if (quota.mainlandPhone) {
            quota.mainlandPhone = quota.mainlandPhone.replace(/86-/g, "");
          }
          if (quota.hkPhone) {
            quota.hkPhone = quota.hkPhone.replace(/852-/g, "");
          }
          // 澳門聯絡地址回顯
          const applyAddress = res.spRemark && res.spRemark.applyAddress;
          const macauAddressText =
            quota.macauAddress && quota.macauAddress.textCn;
          if (applyAddress && applyAddress == macauAddressText) {
            quota.vssMacauAddress = macauAddressText;
          } else {
            quota.vssMacauAddress = "other";
          }
        }
        // 其他國籍處理
        // 電話去掉區號
        let drivers = application.drivers;
        if (drivers && drivers.length > 0) {
          drivers = drivers.map((ele) => {
            if (ele.otherNationality) {
              ele.otherNationalityText = res.nationality;
              ele.nationality = "XXX";
            }
            if (ele.mainlandPhone) {
              ele.mainlandPhone = ele.mainlandPhone.replace(/86-/g, "");
            }
          });
          if (drivers.otherNationality) {
            drivers.otherNationalityText = res.nationality;
            drivers.nationality = "XXX";
          }
        }
        // 內地車牌去除“粤”
        let vehicle = application.vehicle;
        if (vehicle) {
          vehicle.regAndIdNo = vehicle.registrationNo;
          if (vehicle.mainlandRegistrationNo) {
            vehicle.mainlandRegistrationNo =
              vehicle.mainlandRegistrationNo.replace(/(粤|粵)/g, "");
          }
        }
        // 續期spNo默認取接口
        if (this.applicationType == "RENEW") {
          verifyForm.spNo = res.appCdMo;
          resetForm = res.application;
        }
        resetForm = res.application;
      } else {
        let quota = resetForm.quota;
        // 否則根據准入信息預填數據
        if (this.applicantType == "PERSON") {
          quota.personNameCn = res.custCname ? res.custCname.toUpperCase() : "";
          quota.personNameEn = res.custPname ? res.custPname.toUpperCase() : "";
          quota.personIdentityNo = verifyForm.identityNo;
        } else {
          quota.companyNameCn = res.custCname;
          quota.companyNameEn = res.custPname;
          quota.companyIdentityType = verifyForm.companyType;
          quota.companyBrNo = verifyForm.companyNo;
        }
        quota.macauMobile = res.custMobile;
        if (this.applicationType == "FIRST") {
          let cheque = resetForm.cheque;
          cheque.amount = (this.config && this.config.amount) || 0;
        }
        if (this.applicationType == "RENEW") {
          verifyForm.spNo = res.appCdMo;
          verifyForm.hzmbSubtype = res.hzmbSubtype;
          this.$store.commit("changeVssForm", verifyForm);
          let vehicle = resetForm.vehicle;
          vehicle.registrationNo = res.plateNo;
          vehicle.regAndIdNo = res.plateNo;
          vehicle.identificationNo = verifyForm.identificationNo;
          if (res.owenerMobileCn)
            quota.mainlandPhone = res.owenerMobileCn.replace(/86-/g, "");
          if (res.owenerEmail) quota.mainlandEmail = res.owenerEmail;
          if (res.plateNoCn) vehicle.mainlandRegistrationNo = res.plateNoCn;
        }
      }
      // console.log("resetForm: ", resetForm);
      return resetForm;
    },
  },
  async created() {
    try {
      this.config = await ServiceTypeConfigAPI.getDetails(this.serviceType);
    } catch (error) {
      this.$error(error);
    }
    this.getVss();
    // if (
    //   this.$store.state.serviceType == "HZMB_FIRST_PERSON" ||
    //   this.$store.state.serviceType == "HZMB_RENEW_PERSON"
    // ) {
    //   // 身份證
    //   this.form.quota.personIdentityNo =
    //     this.$store.state.verifyForm.identityNo;
    // } else {
    //   // 配額公司的商業登記類型和編號
    //   this.form.quota.companyIdentityType =
    //     this.$store.state.verifyForm.companyType;
    //   this.form.quota.companyBrNo = this.$store.state.verifyForm.companyNo;
    // }
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.pub_btn {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  .el-button {
    margin-left: 16px;
  }
}
.macauAddress .el-input {
  margin-bottom: 22px;
}
.macauAddress .el-row .el-col:last-child .el-input {
  margin-bottom: 0;
}
/deep/.el-form .el-form-item__label {
  display: block;
  width: 100%;
  text-align: left;
}
.form_type1_box {
  max-width: 760px;
  margin: 24px auto;
}
.next_btn {
  .gradient_btn {
    width: 300px;
    max-width: 100%;
  }
}
</style>
